import { MDText } from 'i18n-react';

import LocalTexts from './sectionState.texts.json';

const LocalT = new MDText(LocalTexts);

export const SECTION_STATES = Object.freeze({
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  COMPLETED: 'completed',
  REACTIVATED: 'reactivated',
});

export const getSectionState = (
  { completed, dependencyCompleted, reactivated }:
  { completed?: boolean; dependencyCompleted?: boolean; reactivated?: boolean },
): {
  state: string;
  tileStatus: React.ReactNode;
} => {
  let state;
  let tileStatus;

  switch (true) {
  case dependencyCompleted === false && !completed:
    state = SECTION_STATES.BLOCKED;
    tileStatus = LocalT.translate('completeDependency');
    break;
  case completed && !reactivated:
    state = SECTION_STATES.COMPLETED;
    break;
  case reactivated:
    state = SECTION_STATES.REACTIVATED;
    tileStatus = LocalT.translate('actionRequired');
    break;
  default:
    state = SECTION_STATES.ACTIVE;
    tileStatus = LocalT.translate('incomplete');
  }

  return {
    state,
    tileStatus,
  };
};
